<template>
  <div class="card">
    <div class="form-title">
      Mes préférences alimentaires
    </div>

    <div>
      <div class="card-content">
        <div>
          <strong>Option d'alimentation:</strong> {{ option }}
        </div>

        <div>
          <strong>Privilégier les aliments bon marché:</strong> {{ preferences.prefer_cheap_meals ? "Oui" : "Non" }}
        </div>

        <div>
          <strong>Préférences pour le petit déjeuner:</strong> {{ preferedBreakfast }}
        </div>

        <div>
          <strong>Nombre de repas contenant de la viande par semaine:</strong> {{ nbMeatDishPerWeek }}
        </div>

        <div>
          <strong>Nombre de repas contenant du poisson par semaine:</strong> {{ nbFishDishPerWeek }}
        </div>

        <div>
          <strong>Quand est-ce que je préfère manger de la viande et du poisson:</strong> {{
          preferencesForWhenToEatMeatAndFish }}
        </div>

        <div>
          <strong>Mon pays:</strong> {{ preferences.country_code }}
        </div>

        <div>
          <strong>Lieu ou j'achète mes courses (Code postal):</strong> {{ preferences.zipcode }}
        </div>
      </div>

      <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
        <button class="button" @click="edit = true" style="margin-right: 10px;">
          <font-awesome-icon :icon="['fas', 'edit']" />
          Modifier
        </button>
      </div>
    </div>

    <EditPreferencesModal v-if="edit" :preferences="preferences" @close="edit = false" />
  </div>
</template>

<script>

import EditPreferencesModal from "@/components/EditPreferencesModal.vue";
import { userState } from "@/utils/store";

export default {
  name: "Preferences",
  components: {
    EditPreferencesModal,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    nbMeatDishPerWeek() {
      return this.preferences.option === "vegetarian" ? 0 : this.preferences.nb_meat_dish_per_week;
    },
    nbFishDishPerWeek() {
      return this.preferences.option === "vegetarian" ? 0 : this.preferences.nb_fish_dish_per_week;
    },
    preferences() {
      return userState.me.consumer_account;
    },
    option() {
      return {
        "none": "Aucune",
        "vegetarian": "Végétarien",
        "gluten-free": "Sans gluten",
        "low-glycemic": "Index glycémique bas",
        "low-glycemic-index": "Index glycémique bas",
      }[this.preferences.option] || "Aucune";
    },
    preferedBreakfast() {
      return {
        "either": "Peu importe",
        "sweet": "Sucré",
        "salty": "Salé",
      }[this.preferences.prefered_breakfast] || "Aucun";
    },
    preferencesForWhenToEatMeatAndFish() {
      return {
        "either": "Peu importe",
        "lunch": "Déjeuner",
        "diner": "Dîner",
      }[this.preferences.preferences_for_when_to_eat_meat_and_fish] || "Aucun";
    },
  },
};

</script>


<style scoped>
.card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}


.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  grid-template-columns: 1fr 2fr;
  grid-template-rows: auto;
  grid-auto-flow: row;
}
</style>
